import React from 'react';

const useVisualizadorImagenes = ({ item, renderImageItem, instalacionLogo }) => {
  const inicializarListaImagenes = () => {
    if (item.listaImagenesArticulos === undefined || item.listaImagenesArticulos.length === 0) {
      return undefined;
    }

    let lista = [];

    item.listaImagenesArticulos.forEach((i, index) => {
      const fixedPath = i.path.replace(/\\/g, '/');
      
      let imagen = {};
      imagen.original = index === 0 ? fixedPath : undefined;
      imagen.articuloItem = i;
      imagen.renderItem = renderImageItem;
      imagen.cargando = true;
      imagen.index = index;
      imagen.hasError = false; // para manejar errores de carga de las fotos

      lista.push(imagen);
    });

    return lista;
  };

  const [listaImagenes, setListaImagenes] = React.useState(inicializarListaImagenes());
  const [imagenesValidas, setImagenesValidas] = React.useState(true);

  const onImageLoad = (index) => {
    if (!listaImagenes) return;

    let newListaImagenes = [...listaImagenes]
    newListaImagenes[index].cargando = false;
    setListaImagenes(newListaImagenes);
  }

  // En caso de error, reemplazo imagen del artículo por la imagen por defecto
  // y verifico si todas las imágenes han fallado
  const onImageError = (index) => {
    if (!listaImagenes) return;

    const newListaImagenes = [...listaImagenes];
    newListaImagenes[index].original = instalacionLogo;
    newListaImagenes[index].cargando = false;
    newListaImagenes[index].hasError = true;
    setListaImagenes(newListaImagenes);

    // Verificar si todas las imágenes han fallado
    const todasFallidas = newListaImagenes.every(img => img.hasError);
    if (todasFallidas) {
      setImagenesValidas(false);
    }
  };

  const onImageGallerySlide = (index) => {
    if (!listaImagenes || !item.listaImagenesArticulos) return;

    let newListaImagenes = [...listaImagenes];
    // Asignar la ruta solo si no ha habido error previo
    if (!newListaImagenes[index].hasError) {
      newListaImagenes[index].original = item.listaImagenesArticulos[index].path;
    }
    setListaImagenes(newListaImagenes);
  }
  
  return {
    listaImagenes,
    imagenesValidas,
    onImageLoad,
    onImageError,
    onImageGallerySlide,
  }
};

export default useVisualizadorImagenes;
